const VideoContext = {
  Welcome: 'Welcome to TruBalance', // Uploaded
  BioenergeticAnalysis: 'Bioenergetic Analysis', // Uploaded
  DemoScan: 'Demo Scan', // Uploaded
  ImprintRemedy: 'Imprint Remedy', // Uploaded
  FocusScan: 'Focus Scan',
  AfterScan: 'After the Scan',
  WhatToShare: 'What to Share',
  WhatIsBioenergeticTesting: 'What is Bioenergetic Testing', // Uploaded
  AppOverview: 'App Overview',
  CreatingClientChart: 'Creating Client Chart',
  SchedulingClients: 'Sheduling Clients',
  CostPaymentProcess: 'Cost & Payment Process',
  SupplementReport: 'Supplement Report',
  RootCauseScan: 'Root Cause Scan',
  EmotionalScan: 'Emotional Scan',
  FocusScan: 'Focus Scan',
  AfterTheScans: 'After the Scans',
  ReportWalkthrough: 'Report Walkthrough',
}

export default VideoContext;